"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.technicalError = exports.availabilityErrorCodes = exports.OjError = exports.getError = void 0;
const _1 = require(".");
class OjError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, OjError.prototype);
    }
}
exports.OjError = OjError;
const availabilityErrorCodes = ['E0018', 'E0301'];
exports.availabilityErrorCodes = availabilityErrorCodes;
const noAvailabilityErrorKey = 'error.E0301';
const errorLabel = 'Error';
const supplierErrorDictPrefix = 'error.';
const technicalError = 'We are sorry but we are experiencing some technical difficulty';
exports.technicalError = technicalError;
const employeeErrorMapping = {
    'error.E0009': 'The location selected is not currently accepting employee travel reservations for your chosen dates. Please select a different location.',
    'error.E0301': 'We are sorry, there are no longer available rooms on the dates you have requested, as they have sold out since the last calendar update.  Please do not reach out directly to the hotel to inquire about availability.',
};
const getError = (errorInput) => {
    const { language, employee, propertyMetaData, supplierErrors, apiErrors } = errorInput;
    let errorResponse = {
        messageDictKey: _1.setDictionaryKey('', [], true),
    };
    if (supplierErrors && supplierErrors.length) {
        errorResponse = supplierErrors === null || supplierErrors === void 0 ? void 0 : supplierErrors.reduce((errorReturn, error) => {
            if (!errorReturn.messageDictKey.key && error.errorCode) {
                return Object.assign(Object.assign({}, errorReturn), { errorCode: error.errorCode, labelDictKey: _1.setDictionaryKey(errorLabel), messageDictKey: _1.setDictionaryKey(supplierErrorDictPrefix + error.errorCode, [], true) });
            }
            return errorReturn;
        }, { messageDictKey: _1.setDictionaryKey('') });
    }
    if (!(errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.messageDictKey.key)) {
        if (apiErrors && apiErrors.length) {
            errorResponse = apiErrors === null || apiErrors === void 0 ? void 0 : apiErrors.reduce((errorReturn, error) => {
                if (!errorReturn.messageDictKey.key && error.errorCode) {
                    return Object.assign(Object.assign({}, errorReturn), { errorCode: error.errorCode, labelDictKey: _1.setDictionaryKey(errorLabel), messageDictKey: _1.setDictionaryKey(error.errorCode, [], true), field: error.field });
                }
                return errorReturn;
            }, { messageDictKey: _1.setDictionaryKey('') });
        }
    }
    if (!(errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.messageDictKey.key)) {
        return errorResponse;
    }
    if (errorResponse.errorCode &&
        ['E0001', 'E0002', 'E0003', 'E0004', 'E0005'].includes(errorResponse.errorCode)) {
        errorResponse.field = 'checkinDate';
    }
    if (errorResponse.messageDictKey.key === 'error.E0304') {
        errorResponse.field = 'destination.locationByCode.code';
    }
    if (employee) {
        errorResponse.messageDictKey.key =
            employeeErrorMapping[errorResponse.messageDictKey.key] ||
                errorResponse.messageDictKey.key;
    }
    if (errorResponse.messageDictKey.key === 'error.E0009') {
        errorResponse.field = 'discountCode';
    }
    if (errorResponse.errorCode &&
        availabilityErrorCodes.includes(errorResponse.errorCode) &&
        !!propertyMetaData) {
        if (errorResponse.messageDictKey.key === noAvailabilityErrorKey) {
            if ((propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.reservationPhone) || (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.propertyPhone)) {
                errorResponse.descriptionDictKey = _1.setDictionaryKey("If your dates are flexible, please contact our <a href=''{0}''>Worldwide Reservations Office</a> or speak to a hotel reservation agent at {1}.", [
                    'https://www.fourseasons.com/contact-us/',
                    propertyMetaData.reservationPhone || propertyMetaData.propertyPhone,
                ], true);
            }
            else {
                errorResponse.descriptionDictKey = _1.setDictionaryKey("If your dates are flexible, please contact our <a href=''{0}''>Worldwide Reservations Office</a>.", ['https://www.fourseasons.com/contact-us/'], true);
            }
        }
        else if ((propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.reservationPhone) || (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.propertyPhone)) {
            errorResponse.descriptionDictKey = _1.setDictionaryKey("For assistance, please contact our <a href=''{0}''>Worldwide Reservations Office</a> or speak to a hotel reservation agent at {1}.", [
                'https://www.fourseasons.com/contact-us/',
                propertyMetaData.reservationPhone || propertyMetaData.propertyPhone,
            ], true);
        }
        else {
            errorResponse.descriptionDictKey = _1.setDictionaryKey("For assistance, please contact our <a href=''{0}''>Worldwide Reservations Office</a>.", ['https://www.fourseasons.com/contact-us/'], true);
        }
        errorResponse.contactReservations = {
            propertyName: propertyMetaData.name || '',
            propertyPhone: propertyMetaData.reservationPhone || propertyMetaData.propertyPhone || '',
        };
        if (propertyMetaData.regionId && propertyMetaData.regionId.includes('north-america')) {
            errorResponse.contactReservations.globalSupportPhone =
                propertyMetaData.globalSupportPhone;
        }
        else if (propertyMetaData.globalTollFreeLink) {
            errorResponse.contactReservations.globalTollFreeLink = {
                url: propertyMetaData.globalTollFreeLink,
                textDictKey: _1.setDictionaryKey('Toll Free Numbers By Country'),
            };
        }
    }
    let languagePath = '/';
    if (language && language !== 'en') {
        languagePath = `/${language}/`;
    }
    if (errorResponse.messageDictKey.key === 'error.CE0001') {
        errorResponse.messageDictKey.params = [
            (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.shortName) || '',
            (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.openingDate) || '',
        ];
        errorResponse.field = 'checkinDate';
    }
    if (errorResponse.messageDictKey.key.includes('errors.bookingSearch.couldNotRetrieve')) {
        errorResponse.messageDictKey.key = 'error.E0101couldnotretrieve';
        errorResponse.messageDictKey.params = [
            `https://www.fourseasons.com${languagePath}find_a_hotel_or_resort/`,
        ];
    }
    if (errorResponse.messageDictKey.key.includes('confirmation.locked')) {
        errorResponse.messageDictKey.key =
            'There was a problem looking up your reservation. Please contact our <a href="{0}">Worldwide Reservations Office</a>.';
        errorResponse.messageDictKey.params = [(propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.globalTollFreeLink) || ''];
    }
    if (errorResponse.errorCode === 'E0020') {
        const propertyType = (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.type) || '';
        if (propertyType.toLowerCase().includes('lodge')) {
            errorResponse.messageDictKey.key =
                "We''re sorry, {0} does not support online booking at this time. Please call the Lodge or our Worldwide Reservations Office for assistance.";
        }
        else if (propertyType.toLowerCase().includes('resort')) {
            errorResponse.messageDictKey.key = 'error.E0020.theresort';
        }
        else {
            errorResponse.messageDictKey.key = 'error.E0020.thehotel';
        }
        errorResponse.messageDictKey.params = [
            `${(propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.typeName) || ''} ${(propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.name) || ''}`.trim(),
        ];
    }
    if (errorResponse.errorCode === 'E0006') {
        errorResponse.messageDictKey.params = ['https://www.fourseasons.com/contact-us/'];
        errorResponse.field = 'checkoutDate';
    }
    if (errorResponse.errorCode === 'E0063') {
        const cards = propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.supportedCreditCards;
        if (cards && cards.length) {
            const ccTypesString = cards.reduce((types, card) => {
                if (card.icon && card.title) {
                    return types ? `${types}, ${card.title}` : card.title;
                }
                return types;
            }, '');
            errorResponse.messageDictKey.params = [ccTypesString];
        }
        else {
            errorResponse.messageDictKey.key = 'error.E0063.supported.CC.types.empty';
        }
    }
    if (errorResponse.errorCode === 'E0065') {
        errorResponse.messageDictKey.params = [
            (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.reservationPhone) || (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.propertyPhone) || '',
        ];
    }
    if (errorResponse.errorCode === 'OJ-01-0400') {
        if ((propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.reservationPhone) || (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.propertyPhone)) {
            errorResponse.messageDictKey.params = [
                (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.reservationPhone) || (propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.propertyPhone),
            ];
        }
        else {
            errorResponse.messageDictKey.key = 'OJ-01-0400-tollfree';
            errorResponse.messageDictKey.params = [
                `https://www.fourseasons.com${(propertyMetaData === null || propertyMetaData === void 0 ? void 0 : propertyMetaData.globalTollFreeLink) || ''}`,
            ];
        }
    }
    return errorResponse;
};
exports.getError = getError;
